<app-header></app-header>
<app-presidents></app-presidents>
<app-right-side></app-right-side>
<div class="container" [dir]="direction">
    <div class="row">
        <div class="col col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="clients-grid">

                <ul class="cat-list-bg-style align-center sorting-menu">
                    <li class="cat-list__item active" data-filter="*"><a routerLink="/executive-committee" class=""><strong> {{'executive-committee.executive_committee' | translate}} </strong> </a></li>
                    <li class="cat-list__item" data-filter=".politics">
                        <a routerLink="/honorable-committee" class="">
                            <strong> {{'executive-committee.honorable_committee' | translate}} </strong></a>
                    </li>
                    <li class="cat-list__item" data-filter=".natural">
                        <a routerLink="/iffhs-members" class="">
                            <strong> {{'executive-committee.iffhs_member' | translate}} </strong></a>
                    </li>
                    <li class="cat-list__item" data-filter=".worlds">
                        <a routerLink="/president-consultant" class="">
                            <strong> {{'executive-committee.president_consultant' | translate}} </strong> </a>
                    </li>
                    <li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/president-assistants" class="">
                            <strong> {{'executive-committee.president_assistant' | translate}} </strong> </a>
                    </li>
                    <!--<li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/gala-award" class="">
                            <strong> {{'executive-committee.iffhs_awards' | translate}} </strong> </a>
                    </li>-->
                    <li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/ranking" class="">
                            <strong> {{'executive-committee.ranking' | translate}} </strong> </a>
                    </li>
                    <!--<li class="cat-list__item" data-filter=".animals">
                        <a routerLink="/history" class="">
                            <strong> {{'executive-committee.history' | translate}} </strong> </a>
                    </li>-->
                </ul>

                <div class="row sorting-container" id="clients-grid-1" data-layout="masonry">

                    <div class="col col-xl-7 col-lg-6 col-md-12 col-sm-12 col-12 sorting-item ecommerce natural">
                        <div class="ui-block">

                            <article class="hentry post has-post-thumbnail" style="padding-top: 70px;">

                                <div class="post__author author vcard inline-items">


                                </div>


                                <div class="post-thumb">
                                    <a href="javascript:void(0);" (click)="onClick(images[13])" id="saleh" style="position: absolute;margin-top: 150px; margin-left: 110px;">
                                        <span style="opacity:0;">saleh<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[0])" id="julio" style="position: absolute;margin-top: 250px; margin-left: 55px;">
                                        <span style="opacity: 0">Julio<br><BR><BR></span>
                                    </a>

                                    <a href="javascript:void(0);" id="clovis" (click)="onClick(images[1])" style="position: absolute;margin-top:240px; margin-left:255px;">
                                        <span style="opacity: 0">robert<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" id="jorgen" (click)="onClick(images[2])" style="position: absolute;margin-top:280px; margin-left:405px;">
                                        <span style="opacity: 0">ashish<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[3])" style="position: absolute;margin-top:280px; margin-left:95px;">
                                        <span style="opacity: 0">ignatius<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" id="robert" (click)="onClick(images[4])" style="position: absolute;margin-top:260px; margin-left:405px;">
                                        <span style="opacity: 0">igor<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[5])" id="igor" style="position: absolute;margin-top:330px; margin-left:350px;">
                                        <span style="opacity: 0">kilani<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[6])" style="position: absolute;margin-top:400px; margin-left:255px;">
                                        <span style="opacity: 0">jasem<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[7])" style="position: absolute;margin-top:365px; margin-left:415px;">
                                        <span style="opacity: 0">khaled<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[8])" style="position: absolute;margin-top:425px; margin-left:110px;">
                                        <span style="opacity: 0">clovis<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[9])" id="jose" style="position: absolute;margin-top:385px; margin-left:45px;">
                                        <span style="opacity: 0">jose<br><BR><BR> </span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[10])" id="marcelo" style="position: absolute;margin-top:330px; margin-left:95px;">
                                        <span style="opacity: 0">marcelo<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[11])" id="yassine" style="position: absolute;margin-top:500px; margin-left:180px;">
                                        <span style="opacity: 0">yassine<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[12])" id="gianluca" style="position: absolute;margin-top:500px; margin-left:250px;">
                                        <span style="opacity: 0">gianluca<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[13])" id="juliet" style="position: absolute;margin-top:500px; margin-left:300px;">
                                        <span style="opacity: 0">juliet<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[14])" id="abdelaziz" style="position: absolute;margin-top:480px; margin-left:350px;">
                                        <span style="opacity: 0">abdelaziz<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[15])" id="marko" style="position: absolute;margin-top:550px; margin-left:250px;">
                                        <span style="opacity: 0">marko<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[16])" id="nathalia" style="position: absolute;margin-top:550px; margin-left:180px;">
                                        <span style="opacity: 0">nathalia<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[17])" id="xiao" style="position: absolute;margin-top:550px; margin-left:320px;">
                                        <span style="opacity: 0">xiao<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[18])" id="kim" style="position: absolute;margin-top:350px; margin-left:200px;">
                                        <span style="opacity: 0">kim<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[19])" id="joe" style="position: absolute;margin-top: 500px; margin-left: 50px;">
                                        <span style="opacity: 0">joe<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[20])" id="sergio" style="position: absolute;margin-top:480px; margin-left:400px;">
                                        <span style="opacity: 0">sergio<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[21])" id="ibrahim" style="position: absolute;margin-top: 440px; margin-left: 400px;">
                                        <span style="opacity: 0">ibrahim<br><BR><BR></span>
                                    </a>
                                    <a href="javascript:void(0);" (click)="onClick(images[22])" id="mohamed" style="position: absolute;margin-top:550px; margin-left:50px;">
                                        <span style="opacity: 0">mohamed<br><BR><BR></span>
                                    </a>

                                    <img src="assets/img/ex-co.jpeg" alt="photo" width="523" height="720">
                                </div>

                            </article>
                        </div>
                    </div>

                    <div class="col col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12 sorting-item worlds family politics">
                        <div class="ui-block">
                            <article class="hentry post has-post-thumbnail">
                                <div class="post__author author vcard inline-items">

                                </div>
                                <!-- [id] ="post.id" -->
                                <div class="post-thumb">
                                    <a routerLink="/profile-details" [queryParams]="{'id': imageSrc.id , 'role':'User'}"> <img src="{{imageSrc.src}}" > </a>
                                    <br>
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">{{'executive-committee.name' | translate}}</th>
                                                <th scope="col"> <a routerLink="/profile-details" [queryParams]="{'id': imageSrc.id , 'role':'User'}" class="h5 author-name" style="color: #3f4257;">{{imageSrc.name}}
                                                    </a></th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td scope="col">{{'executive-committee.position' | translate}}</td>
                                                <td>{{imageSrc.position}}</td>
                                            </tr>
                                            <tr>
                                                <td scope="col">{{'executive-committee.nationality' | translate}}</td>
                                                <td> <img *ngIf="language != 'en'" src="{{imageSrc.flag}}" style="width: 30px; height: 20px; float: left;margin: 0px 12px;"> {{imageSrc.nationality}} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </article>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <!-- <app-iffhs-news></app-iffhs-news> -->
    </div>
</div>